<template>
    <CContainer class="d-flex content-center min-vh-100">
      <div class="col-md-8">
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <form id="login">
                <h1>Login</h1>
                <p class="text-muted">{{ $t('login.sign_in_account') }}</p>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><CIcon name="cil-user"/></span>
                  </div>
                  <input type="email" v-model="email" class="form-control" name="email" id="email" :placeholder="$t('login.email')" required="required">
                </div>

                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><CIcon name="cil-lock-locked"/></span>
                  </div>
                  <input type="password" v-model="password" class="form-control" :placeholder=" $t('login.password')" required="required">
                </div>
                <div class="form-group text-danger">
                  <div class="form-control-feedback">{{ this.errorMsg }}</div>
                </div>
                 <CRow>
                  <CCol col="6" class="text-left">
                    <button type="submit" class="btn btn-primary" @click.stop.prevent="login">{{ $t('login.login') }}</button>
                  </CCol>
                </CRow>
              </form>

            </div>
          </div>
          <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
            <div class="card-body text-center">
              <div>
                <h2>LME EXP (HK) LIMITED</h2>
                <div>Address: UNIT 1805-1806, 18/F HOLLYWOOD</div>
                <div>PLAZA 610 NATHAN RD MONGKOK</div>
                <div>Hong Kong</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </CContainer>

</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      errorMsg: ''
    }
  },
  methods: {
    login () {
      this.axios.post('/auth/login', {
        email: this.email,
        password: this.password
      }).then(response => {
        if(response){
          response.data && localStorage.setItem('access_token', response.data.access_token)
          localStorage.setItem('user_name', this.email)
        }
        if (this.$route.query.redirect) {
          console.log("xxx", this.$route.query.redirect)
          this.$router.push(this.$route.query.redirect)
        } else {
          console.log("23ggg4234")
          this.$router.push('dashboard')
        }
      }).catch(error => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('user_name')
        if (error.message) {
          this.errorMsg = error.message
        }else if (error.data && error.data.error) {
          this.errorMsg = error.data.error
        }
        console.log("234234",error)
      })
    }
  }
}
</script>
